import './App.css';
import {Nav} from "./components/Nav/Nav";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import {Home} from "./pages/Home/Home"
import {Publications} from "./pages/Publications/Publications";
import React from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
    return (
        <>
        <head>
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
            <meta name="description" content="" />
            <meta name="author" content="" />
            <title>Bare - Start Bootstrap Template</title>
            <link rel="icon" type="image/x-icon" href="assets/favicon.ico" />
            <link href="css/styles.css" rel="stylesheet" />
        </head>
        <Router>
            <Routes>
                <Route path={"/"} element={<Home />} />
                <Route path={"/publications"} element={<Publications />} />
            </Routes>
        </Router>
            </>
    );
}

export default App;
